// API Configuration for OSOP Coding Institute
// Domain: https://osopcoding.com

const API_CONFIG = {
  // Base URLs
  PRODUCTION_BASE_URL: 'https://osopcoding.com/api',
  DEVELOPMENT_BASE_URL: 'http://localhost/server-php/api',
  
  // Current environment
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // Get base URL based on environment
  getBaseURL: () => {
    return API_CONFIG.IS_PRODUCTION 
      ? API_CONFIG.PRODUCTION_BASE_URL 
      : API_CONFIG.DEVELOPMENT_BASE_URL;
  },
  
  // API Endpoints
  ENDPOINTS: {
    // Admin endpoints
    ADMIN_LOGIN: '/admin/login',
    ADMIN_LOGOUT: '/admin/logout',
    
    // Enquiries
    ENQUIRIES: '/enquiries',
    ENQUIRIES_STATISTICS: '/enquiries/statistics',
    ENQUIRIES_EXPORT: '/enquiries/export',
    
    // Franchise enquiries
    FRANCHISE_ENQUIRIES: '/franchise-enquiries',
    FRANCHISE_ENQUIRIES_STATISTICS: '/franchise-enquiries/statistics/overview',
    
    // Hiring requests
    HIRING_REQUESTS: '/hiring-requests',
    HIRING_REQUESTS_STATISTICS: '/hiring-requests/statistics',
    HIRING_REQUESTS_EXPORT: '/hiring-requests/export',
    
    // Promotional slides
    PROMOTIONAL_SLIDES: '/promotional-slides',
    PROMOTIONAL_SLIDES_ACTIVE: '/promotional-slides/active',
    PROMOTIONAL_SLIDES_ADMIN: '/promotional-slides/admin/all',
    PROMOTIONAL_SLIDES_STATISTICS: '/promotional-slides/statistics/overview',
    
    // Franchise hero images
    FRANCHISE_HERO_IMAGES: '/franchise-hero-images',
    
    // Coupons
    COUPONS: '/coupons',
    COUPONS_ACTIVE: '/coupons/active',
    COUPONS_BY_CATEGORY: '/coupons/by-category',
    COUPONS_CATEGORIES: '/coupons/categories',
    
    // Contact
    CONTACTS: '/contacts',
    CONTACTS_STATISTICS: '/contacts/statistics',
    CONTACTS_SEARCH: '/contacts/search',
    
    // Workshop Registrations
    WORKSHOP_REGISTRATIONS: '/workshop-registrations',
    WORKSHOP_REGISTRATIONS_STATISTICS: '/workshop-registrations/statistics',
    WORKSHOP_REGISTRATIONS_SEARCH: '/workshop-registrations/search',
    WORKSHOP_REGISTRATIONS_WORKSHOPS: '/workshop-registrations/workshops',
    
    // Placement Resumes
    PLACEMENT_RESUMES: '/placement-resumes',
    PLACEMENT_RESUMES_STATISTICS: '/placement-resumes/statistics',
    PLACEMENT_RESUMES_SEARCH: '/placement-resumes/search',
    PLACEMENT_RESUMES_CITIES: '/placement-resumes/cities',
    
    // Test endpoints
    TEST_API: '/test',
    TEST_HEADERS: '/test-headers',
  },
  
  // Headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Timeout settings
  TIMEOUT: 30000, // 30 seconds
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
  
  // Cache settings
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
  
  // File upload settings
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
};

// Helper functions
export const getApiUrl = (endpoint) => {
  const baseURL = API_CONFIG.getBaseURL();
  return `${baseURL}${endpoint}`;
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  if (imagePath.startsWith('data:')) return imagePath;
  
  const baseURL = API_CONFIG.IS_PRODUCTION 
    ? 'https://osopcoding.com/server-php' 
    : 'http://localhost/server-php';
    
  // Remove any leading slash to avoid double slashes
  const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
  return `${baseURL}/${cleanPath}`;
};

export const addCacheBuster = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_t=${Date.now()}`;
};

export default API_CONFIG; 